import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { updatePurchaseRequest } from "@surgia/api/src/hub/purchaseRequest";
import { useState } from "react";
export const useUpdatePurchaseRequest = (draftQueryParams?: {
  branchId: string;
  componentId: string;
  tenantId: string;
  draftPurchaseRequestID: string;
  minQuantity?: number;
  maxQuantity?: number;
  currentQuantity?: number;
}) => {
  const queryClient = useQueryClient();
  const [allTenantProductsInvalidationPending, setAllTenantProductsInvalidationPending] = useState(false);
  const mutation = useMutation({
    mutationFn: async (variables: {
      branchId: string;
      componentId: string;
      tenantId: string;
      body: { quantity: number; tenant_product_id: string };
    }) => {

      // Validate quantity before making the API call
      if (draftQueryParams?.minQuantity && variables.body.quantity < draftQueryParams.minQuantity) {
        toast.error(`Quantity cannot be less than ${draftQueryParams.minQuantity}`);
        throw new Error('VALIDATION_ERROR');
      }
      if (draftQueryParams?.maxQuantity && variables.body.quantity > draftQueryParams.maxQuantity) {
        toast.error(`Quantity cannot be greater than ${draftQueryParams.maxQuantity}`);
        throw new Error('VALIDATION_ERROR');
      }
     
      // If validation passes, proceed with the actual mutation
      await updatePurchaseRequest(
        variables.branchId,
        variables.componentId, 
        variables.tenantId,
        variables.body
      );

    },
    onSuccess: async() => {
      toast.success("Item quantity updated successfully");
      // Invalidate the specific purchase request by ID
      queryClient.invalidateQueries({
        queryKey: ['purchaseRequest', 'byId', { id: draftQueryParams?.draftPurchaseRequestID }]
      });
      
      // Invalidate the specific draft query with exact same params
      if (draftQueryParams) {
      const queryKey = [
        "purchaseRequest",
        "draft",
        {
          branchId: draftQueryParams?.branchId,
          componentId: draftQueryParams?.componentId,
          tenantId: draftQueryParams?.tenantId,
        },
      ];
        
        queryClient.invalidateQueries({
          queryKey: queryKey
        });
         queryClient.invalidateQueries({
          predicate: (query) => {
            const keyString = JSON.stringify(query.queryKey);
            return keyString.includes('tenant-products');
          }
        });
      }
      setAllTenantProductsInvalidationPending(true);
    },
    onError: (error) => {
      if (error.message !== 'VALIDATION_ERROR') {
        console.error('Failed to update purchase request:', error);
        toast.error("Failed to update purchase request. Please try again.");
      }
    }
    
  });

  return {
    ...mutation,
    allTenantProductsInvalidationPending
  };
}; 